import React from "react";

import Paper from "@mui/material/Paper";
import { Box, AppBar, Tabs, Tab } from "@mui/material";

import { Alerting } from "components/Settings/Alerting";

import { LanguageSwitcher } from "components/Settings/LanguageSwitcher";
import { PasswordUpdater } from "components/Settings/PasswordUpdater";
import { SimpleTabPanel } from "../components/Header/SimpleTabPanel";
import { translate } from "i18n";
import { WatermarkingSettings } from "components/Settings/WatermarkSettings";
import { PurgeLogs } from "components/Maintenance/PurgeLogs";
import { ServerComponent } from "components/Settings/Server";

export class Settings extends React.Component {
  public state = { tab: 0 };

  constructor(props: any) {
    super(props);
    window.onpopstate = () => {
      window.location.href = "/settings";
    };
  }
  //history manangement, we push this page in order to go back to the mosaic page
  //Note: we can acess to this current page only if we are on the mosaic and if we click on the + button
  private a11yProps(index: any): object {
    return {
      "id": `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  private tabChange = (event: React.ChangeEvent<{}>, tabId: number) => {
    this.setState({ tab: tabId });
  };

  public render(): JSX.Element {
    return (
      <>
        <Box style={{ width: "100%", padding: "2em" }}>
          <Paper elevation={4}>
            <Box>
              <AppBar position="static">
                <Tabs value={this.state.tab} onChange={this.tabChange} indicatorColor="secondary" textColor="inherit">
                  <Tab data-cy="settings-password-update-tab" label={translate("password update title")} {...this.a11yProps(0)} />
                  <Tab data-cy="settings-language-tab" label={translate("language")} {...this.a11yProps(1)} />
                  <Tab data-cy="settings-alerting-tab" label={translate("alerting")} {...this.a11yProps(2)} />
                  <Tab data-cy="settings-watermarking-tab" label={translate("watermarking")} {...this.a11yProps(3)} />
                  <Tab data-cy="settings-purge-logs-tab" label={translate("Logs")} {...this.a11yProps(4)} />
                  <Tab data-cy="settings-restart-acr-tab" label={translate("Server")} {...this.a11yProps(5)} />
                </Tabs>
              </AppBar>
            </Box>

            <SimpleTabPanel value={this.state.tab} index={0}>
              <PasswordUpdater />
            </SimpleTabPanel>
            <SimpleTabPanel value={this.state.tab} index={1}>
              <LanguageSwitcher />
            </SimpleTabPanel>
            <SimpleTabPanel value={this.state.tab} index={2}>
              <Alerting />
            </SimpleTabPanel>
            <SimpleTabPanel value={this.state.tab} index={3}>
              <WatermarkingSettings/>
            </SimpleTabPanel>
            <SimpleTabPanel value={this.state.tab} index={4}>
              <PurgeLogs />
            </SimpleTabPanel>
            <SimpleTabPanel value={this.state.tab} index={5}>
              <ServerComponent/>
            </SimpleTabPanel>
          </Paper>
        </Box>
      </>
    );
  }
}
